// extracted by mini-css-extract-plugin
module.exports = {"tooltipOverlay":"usePopover_tooltipOverlay__2Hq9-","tooltipFloating":"usePopover_tooltipFloating__uNlWR"};